import dayjs from "dayjs";

export const isNotFutureDate = (value) => {
  if (!value) return true;

  // Accepts either a date string (YYYY-MM-DD) or a Date object
  const inputDate = dayjs(value);
  if (!inputDate.isValid()) {
    return false;
  }

  const today = dayjs().startOf("day");
  return inputDate.isSame(today, "day") || inputDate.isBefore(today, "day");
};
